import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSession from 'app/hooks/useSession';
import sessionsModule from 'app/store/sessions';

const { wizardSet } = sessionsModule.actions;

export default function() {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.layout.isLoading);
  const store = useSession();
  const selection = store.getWizardSelection();
  const saveSelection = useCallback(wizard => {
    store.setWizardSelection(wizard);
  }, [store]);

  useEffect(() => {
    if (selection && !isLoading) {
      dispatch(wizardSet(selection));
      store.removeWizardSelection();
    }
  }, [selection, store, isLoading, dispatch]);

  return {
    saveSelection
  };
}
